import { clsx } from '@alexis/helpers/clsx';
import React, { useState } from 'react';

import styles from './FilterCategoryAccordion.module.scss';

type FilterCategoryAccordionProps = {
  children: React.ReactNode;
  isFiltered: boolean;
  title: string;
  isExpanded?: boolean;
};

const FilterCategoryAccordion: React.FC<FilterCategoryAccordionProps> = ({
  children,
  isFiltered,
  title,
  isExpanded = false,
}) => {
  const [isFilterCategoryExpanded, setIsFilterCategoryExpanded] = useState<boolean>(isExpanded);

  return (
    <>
      <div
        className={clsx(styles.categoryHeader, isFilterCategoryExpanded && styles.expanded)}
        onClick={() => setIsFilterCategoryExpanded((prev) => !prev)}
      >
        <h3>
          {title}

          {isFiltered && <div className={styles.filtered} />}
        </h3>

        <i className={clsx(styles.chevron, styles.bottom)}></i>
      </div>

      {isFilterCategoryExpanded ? children : null}
    </>
  );
};

export default FilterCategoryAccordion;
